import { Flex, Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { SubmitFormBtn } from '../Buttons/SubmitFormBtn';
import { TooltipWithTouch } from '../TooltipWithTouch';

export interface IFormFooter {
  submitBtn?: {
    isDisabled?: boolean;
    title: string;
  };
  cancelBtn?: {
    onClick?: VoidFunction;
    title?: string;
  };
  tooltip?: {
    label?: string;
    isDisabled?: boolean;
  };
  [key: string]: any;
}

export const FormFooter = ({ submitBtn, cancelBtn, tooltip, ...restProps }: IFormFooter) => {
  const { t } = useTranslation();
  return (
    <Flex
      w='100%'
      justifyContent='space-between'
      alignItems='center'
      flexDir={{ base: 'column', lg: 'row' }}
      {...restProps}
    >
      {submitBtn ? (
        <TooltipWithTouch label={tooltip?.label} isDisabled={tooltip?.isDisabled}>
          <SubmitFormBtn type='submit' minH={'58px'} isDisabled={submitBtn?.isDisabled}>
            {submitBtn?.title}
          </SubmitFormBtn>
        </TooltipWithTouch>
      ) : null}

      {cancelBtn ? (
        <Button variant='linkUnderlinePrimary' size='sm' onClick={cancelBtn?.onClick} mt={{ base: 6, lg: 0 }}>
          {cancelBtn?.title || t('cancel')}
        </Button>
      ) : null}
    </Flex>
  );
};
